module.exports = __webpack_public_path__ + "stylesheets/newsWebsite_fe9b7f77e4da0de0bc55c6bd85b426a0.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/newsWebsite.less
// module id = b/cW
// module chunks = 153